module.exports = __webpack_public_path__ + "account/assets/telegram.16581b2e.svg";